import { render, staticRenderFns } from "./courseNotice.vue?vue&type=template&id=10db7798&scoped=true&"
import script from "./courseNotice.vue?vue&type=script&lang=js&"
export * from "./courseNotice.vue?vue&type=script&lang=js&"
import style0 from "./courseNotice.vue?vue&type=style&index=0&id=10db7798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db7798",
  null
  
)

export default component.exports